<template>
  <div id="orderlist" style="width: 100%;height: 100%">
    <el-row>
      <el-form :inline="true" :model="searchForm" ref="searchForm" class="demo-form-inline" size="medium" style="padding-top: 0; margin-top: 0;">
        <el-col>
          <el-form-item label="副仓：" v-if="subWarehouseList && subWarehouseList.length > 1">
            <el-select v-model="searchForm.SUB_WAREHOUSE" filterable placeholder="请选择副仓" clearable multiple collapse-tags style="width: 200px;">
              <el-option v-for="item in subWarehouseList" :key="item.ID" :label="item.AB_NAME" :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="供应商：">
            <el-select filterable v-model="searchForm.SUPPLIER" placeholder="请选择" clearable>
              <el-option v-for="item in supplier" :key="item.value" :label="item.NAME" :value="item.SUPPLIER_ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单ID：">
            <el-input v-model="searchForm.orderCode" style="width: 180px;" clearable></el-input>
          </el-form-item>
          <el-form-item label="采购类型：">
            <el-select filterable v-model="searchForm.采购类型" placeholder="请选择" clearable>
              <el-option v-for="item in 采购类型列表" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择日期：">
            <el-date-picker v-model="searchForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="整单备注：">
            <el-input size="medium" clearable v-model="searchForm.REMARKS" placeholder="请输入整单备注"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" id="search" @click="handleSearch()" :loading="loading">筛选</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" plain @click="exportHistoryOrder" v-if="fun_dic[101010001]">导出历史订单</el-button>
            <el-button type="primary" plain @click="exportAllOrder" v-if="fun_dic[101010002]">导出全部订单</el-button>
            <el-button type="primary" plain @click="monthlyDeliveryRecordSummaryDialog = true" v-if="fun_dic[101010003]">
              月度送货记录汇总PDF
            </el-button>
            <tooltip-button :disabled="Boolean(searchForm.DAY_INTERVAL && searchForm.DAY_INTERVAL[0])" tipContent="请先选择日期范围" buttonType="primary"
              buttonPlain buttonText="导出PDF" @click="pdfVisible = true">
            </tooltip-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="changeAllOrder">一键转换代采订单</el-button>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>
    <!-- 选择导出所有订单日期 -->
    <el-dialog title="选择日期" center :visible.sync="exportTatolDialog" width="450px">
      <el-form :model="exportAllForm" ref="exportAllForm" :inline="true" size="small">
        <el-form-item label="起始日期">
          <el-date-picker v-model="exportAllForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close">取 消</el-button>
        <el-button size="small" @click="submitExportDate">确 定</el-button>
      </div>
    </el-dialog>
    <el-row>
      <el-col :span="24">
        <el-table :data="newOrderListData" border stripe show-summary style="width: 100%" :summary-method="getSummaries">
          <el-table-column prop="ID" width="80" min-width="30" label="订单ID"></el-table-column>
          <el-table-column prop="ORDER_CODE" label="订单编号" min-width="160"></el-table-column>
          <el-table-column prop="SEND_DAY" label="送货日期" min-width="115"></el-table-column>
          <el-table-column prop="SUPPLIER_NAME" label="供应商" min-width="130"></el-table-column>
          <!-- <el-table-column prop="TOTAL_GYS_FEE" label="订单总金额（元）" min-width="100"></el-table-column> -->
          <el-table-column prop="REAL_TOTAL_SUPPLIER_FEE" label="实收总金额（元）" min-width="100"></el-table-column>
          <el-table-column prop="REAL_TOTAL_WEIGHT" label="总重" min-width="100"></el-table-column>
          <el-table-column prop="PRINT_TIME" label="打印次数" min-width="100"></el-table-column>
          <el-table-column prop="REMARKS" label="整单备注" min-width="90"></el-table-column>
          <el-table-column fixed="right" label="操作" width="190">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="detail(scope.row)">查看</el-button>
              <el-button type="text" size="small" @click="copyOrder(scope.row)">复制订单
              </el-button>
              <el-button type="text" size="small" @click="printOrder(scope.row)">打印订单</el-button>
              <el-button type="text" size="small" @click="shortPrintOrder(scope.row)">短打印
              </el-button>
              <el-button type="text" size="small" @click="orderContract(scope.row)">订单资质
              </el-button>
              <el-button type="text" size="small" @click="output(scope.row)">导出订单</el-button>
              <el-button type="text" size="small" @click="exportOrderList(scope.row)">导出
              </el-button>
              <el-button v-if="fun_dic[101010004]" type="text" size="small" @click="修改订单(scope.row)">修改订单
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
    <el-dialog title="复制订单" center :visible.sync="copyFormVisible" width="600px">
      <el-form size="small" :model="copyForm" ref="copyForm" :rules="rules">
        <el-form-item label="供应商：" :label-width="formLableWidth" prop="customer">
          <el-select filterable v-model="copyForm.customer" placeholder="请选择供应商" style="width:80%">
            <el-option v-for="item in customers" :key="item.SUPPLIER_ID" :label="item.NAME" :value="item.SUPPLIER_ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="送货日期：" :label-width="formLableWidth" prop="SEND_DAY">
          <el-date-picker v-model="copyForm.SEND_DAY" clearable type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
            style="width:80%"></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close">取 消</el-button>
        <el-button size="small" @click="submitCopy('copyForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 修改公司名称 -->
    <el-dialog title="修改公司名称" center :visible.sync="nameFormVisible" width="600px">
      <el-form :model="nameForm" ref="nameForm" label-width="100px">
        <el-form-item label="公司名称：">
          <el-input v-model="nameForm.companyName"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="nameFormVisible = false">取 消</el-button>
        <el-button @click="submitPrint" v-if="this.nameForm.companyName === ''" disabled>确 定</el-button>
        <el-button @click="submitPrint" v-else>确 定</el-button>
      </div>
    </el-dialog>
    <!-- 提示框 -->
    <el-dialog title="复制失败，以下产品不供应" center :visible.sync="infoFormVisible" width="600px">
      <el-form :model="infoForm" ref="infoForm" label-width="100px">
        <el-table :data="infoData" border stripe>
          <el-table-column prop="PRODUCT_CODE" label="产品编码" min-width="100"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品名称" min-width="100"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位" min-width="100"></el-table-column>
        </el-table>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="infoFormVisible = false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog title="代采客户信息" center :visible.sync="purchaseDialog" width="450px">
      <el-form size="small" ref="purchaseForm" :model="purchaseForm" style="padding-left: 30px;">
        <el-form-item label="选择客户：" :label-width="formLableWidth">
          <el-select filterable v-model="purchaseForm.PRINCIPAL" placeholder="请选择客户" clearable>
            <el-option v-for="item in purchaseList" :key="item.ID" :label="item.AB_NAME" :value="item.ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开始日期：" :label-width="formLableWidth">
          <el-date-picker v-model="purchaseForm.START_DAY" clearable type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
            style="width:76%"></el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期：" :label-width="formLableWidth">
          <el-date-picker v-model="purchaseForm.END_DAY" clearable type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
            style="width:76%"></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="purchaseDialog = false">取 消</el-button>
        <el-button size="small" @click="submitPurchase()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="导出月度送货记录汇总PDF" center :visible.sync="monthlyDeliveryRecordSummaryDialog" width="450px" :close-on-click-modal="false"
      @close="closeMonthlyDeliveryRecordSummaryDialog" :collapse-tags="false">
      <el-form ref="monthlyDeliveryRecordSummaryForm" :model="monthlyDeliveryRecordSummaryForm" :label-width="formLabelWidth">
        <el-form-item label="供应商：" prop="SUPPLIER_ID_LIST">
          <el-select filterable style="width: 90%" v-model="monthlyDeliveryRecordSummaryForm.SUPPLIER_ID_LIST" placeholder="请选择供应商" multiple>
            <el-option v-for="item in supplier" :key="item.SUPPLIER_ID" :label="item.NAME" :value="item.SUPPLIER_ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="月份：" :label-width="formLabelWidth" prop="MONTH">
          <el-date-picker v-model="monthlyDeliveryRecordSummaryForm.MONTH" style="width: 90%" type="month" align="right" value-format="yyyy-MM"
            :clearable="false" placeholder="请选择月份">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeMonthlyDeliveryRecordSummaryDialog">取 消</el-button>
        <tooltip-button :disabled="Boolean(monthlyDeliveryRecordSummaryForm.MONTH[0])" :tipContent="'请先选择月份'" :buttonType="'primary'"
          :buttonText="'确 定'" @click="exportMonthlyDeliveryRecordSummary">
        </tooltip-button>
      </div>
    </el-dialog>
    <V-PurchaseOrderExportPDFForm :Visible="pdfVisible" :orderStatus="7" :startEnd="[...searchForm.DAY_INTERVAL]" @close="pdfVisible = false">
    </V-PurchaseOrderExportPDFForm>

    <el-dialog title="修改订单" center :visible.sync="修改订单模态框" width="500px" :close-on-click-modal="false">
      <el-form size="medium" :model="修改订单表单" ref="修改订单表单" :inline="true">
        <el-form-item label="供应商：" label-width='120px'>
          <el-select v-model="修改订单表单.SUPPLIER_ID" filterable placeholder="请选择供应商" clearable style="width: 300px;">
            <el-option v-for="item in supplier" :key="item.value" :label="item.NAME" :value="item.SUPPLIER_ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="送货日期：" label-width='120px'>
          <el-date-picker size="medium" v-model="修改订单表单.SEND_DAY" type="date" placeholder="选择日期" :clearable="true" style="width: 300px;">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="修改订单模态框 = false">取 消</el-button>
        <el-button size="small" @click="确认修改订单()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  historyOrderFun, exportHistoryFun, exportHistoryAllFun, copyOrderFun, exportNewOrdeFun,
} from 'api/shopOrderManage';
import date from '@/assets/common/date';
import { queryActiveSupplierList } from 'api/customerManage';
import http from '@/assets/common/http';
import { frontEndFun } from '@/assets/api/frontFun';
import VPurchaseOrderExportPDFForm from './purchaseOrderExportPDFForm';

export default {
  data() {
    return {
      subWarehouseList: JSON.parse(sessionStorage.getItem('subWarehouseList')),
      修改订单模态框: false,
      修改订单表单: {},
      PAGE_ID: '1010100', // 页面ID 一旦规定不要轻易改动
      fun_dic: {
        101010001: 0, 101010002: 0, 101010003: 0, 101010004: 0,
      }, // 功能ID 一旦规定不要轻易改动
      loading: false,
      exportTatolDialog: false,
      copyFormVisible: false,
      copyForm: {},
      // loading1: false,
      rules: {
        customer: [
          { required: true, message: '请选择供应商', trigger: 'blur' },
        ],
        SEND_DAY: [
          { required: true, message: '请选择送货日期', trigger: 'blur' },
        ],
      },
      formLableWidth: '100px',
      companys: [
        {
          TC_ID: '',
          AB_Name: '',
        },
      ],
      supplier: [
        {
          NAME: '',
          SUPPLIER_ID: '',
        },
      ],
      newOrderListData: [],
      customers: [],
      currentPage: 1,
      totalCount: 0,
      pageSize: 20,
      采购类型列表: [
        { NAME: '普通采购', ID: 1 },
        { NAME: '直送门店第三方订单', ID: 2 },
      ],
      exportAllForm: {
        DAY_INTERVAL: [],
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      searchForm: {
        COMPANY: '',
        PROJECT: '',
        STATUS: '',
        DAY_INTERVAL: [date(new Date() - 30 * 24 * 60 * 60 * 1000, '%F'), date(new Date(), '%F')],
      },
      nameForm: {},
      nameFormVisible: false,
      sellOrderID: sessionStorage.getItem('sellOrderID'),
      historyOrderFlag: 0,
      infoFormVisible: false,
      infoForm: {},
      infoData: [],
      purchaseDialog: false,
      purchaseForm: {
        PRINCIPAL: '',
        ID: '',
      },
      purchaseList: [],
      IS_SUPPLIER_CLIENT: 0,
      monthlyDeliveryRecordSummaryDialog: false,
      monthlyDeliveryRecordSummaryForm: {
        MONTH: [],
      },
      formLabelWidth: '120px',
      pdfVisible: false,
    };
  },
  components: {
    VPurchaseOrderExportPDFForm,
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (sessionStorage.getItem('store')) {
      this.$store.replaceState(
        { ...this.$store.state, ...JSON.parse(sessionStorage.getItem('store')) },
      );
    }
    if (this.NEWORDER_HISTORY_DATA_CONDITION.CONDITION) {
      this.searchForm = this.NEWORDER_HISTORY_DATA_CONDITION.CONDITION;
      this.currentPage = this.NEWORDER_HISTORY_DATA_CONDITION.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryNewOrderListData();
    this.querySupplier();
    this.queryPurchsse();
    this.queryBeforeFun();
  },
  computed: {
    // 上一次的搜索结果和条件
    NEWORDER_HISTORY_DATA_CONDITION() {
      return this.$store.state.NEWORDER_HISTORY_DATA_CONDITION;
    },
  },
  methods: {
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (index === 6 || index === 7) {
          return;
        }
        const values = data.map((item) => Number(item[column.property])); // 总价列的数组
        if (!values.every((value) => Number.isNaN(value))) {
          // 判断当前列有无NaN  ，有则直接这一列合计为 '--'
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr); // 防止是字符串累加
            if (!Number.isNaN(value)) {
              return prev + value;
            }
            return prev;
          }, 0);
          sums[index] = sums[index].toFixed(2);
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },
    确认修改订单() {
      const params = {
        SERVICE_ID: '10003',
        OTYPE: 57,
        ORDER_ID: this.修改订单表单.ORDER_ID,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        SUPPLIER_ID: this.修改订单表单.SUPPLIER_ID,
        SEND_DAY: date(this.修改订单表单.SEND_DAY, '%F'),
      };
      http.post(params).then((res) => {
        this.queryNewOrderListData();
        this.$message.show({ text: '修改成功', type: 'success' });
        this.修改订单模态框 = false;
        this.修改订单表单 = {};
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    修改订单(row) {
      this.修改订单模态框 = true;
      this.修改订单表单.ORDER_ID = row.ID;
    },
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      frontEndFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    orderContract(row) {
      this.$router.push({ name: 's_contantract', params: { id: row.ID } });
      sessionStorage.setItem('menuName', 3);
    },
    // 复制订单
    copyOrder(row) {
      this.copyFormVisible = true;
      this.copyForm.ORDER_ID = row.ID;
    },
    submitCopy(formName) {
      // 关账限制
      if (this.$util.isOrderClosed(this.copyForm.SEND_DAY)) {
        this.$message.show({ text: '该月份已关账，无法对此订单进行操作', type: 'warning' });
        return false;
      }
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              const params = {
                SUPPLIER_ID: this.copyForm.customer,
                SEND_DAY: date(this.copyForm.SEND_DAY, '%F'),
                ORDER_ID: this.copyForm.ORDER_ID,
                PRICE_MODE: sessionStorage.getItem('PRICE_MODE'),
              };
              copyOrderFun(params).then((result) => {
                if (result[0].ERROR_FLAG !== 0) {
                  this.infoFormVisible = true;
                  this.infoData = result[0].DATA;
                } else {
                  this.$message.show({ text: '复制成功', type: 'success' });
                  this.copyFormVisible = false;
                  this.queryNewOrderListData();
                }
                document.body.style.cursor = 'default';
              }).catch((error) => {
                this.$message.show({ text: error, type: 'error' });
                document.body.style.cursor = 'default';
              });
            } else {
              document.body.style.cursor = 'default';
              return false;
            }
          });
        } finally {}
      }
    },
    detail(row) {
      sessionStorage.setItem('orderId', row.ID);
      sessionStorage.setItem('CAN_MODIFY_PRICE', row.CAN_MODIFY_PRICE);
      this.$router.push({ path: '/s_OrderDetail/detail' });
    },
    // --------------------------------------获取新订单列表
    queryNewOrderListData() {
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      if (this.searchForm.orderCode) {
        params.ORDER_ID = this.searchForm.orderCode;
      }
      if (this.sellOrderID) {
        params.SALE_ORDER_ID = Number(this.sellOrderID);
      }
      if (this.searchForm.SUPPLIER) {
        params.SUPPLIER_ID = this.searchForm.SUPPLIER;
      }
      if (this.searchForm.DAY_INTERVAL != null && this.searchForm.DAY_INTERVAL.length == 2) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      if (this.searchForm.采购类型) {
        params.ORDER_TYPE = this.searchForm.采购类型;
      }
      if (this.searchForm.REMARKS) {
        params.REMARKS = this.searchForm.REMARKS;
      }
      if (this.searchForm.SUB_WAREHOUSE && this.searchForm.SUB_WAREHOUSE[0]) {
        params.GYS_ID_LIST = this.searchForm.SUB_WAREHOUSE;
      }
      this.loading = true;
      historyOrderFun(params).then((result) => {
        if (result[0]) {
          this.newOrderListData = result[0].list;
          this.totalCount = result[0].TOTAL_COUNT;
          this.$store.dispatch('SET_NEWORDER_HISTORY_DATA_CONDITION', {
            CONDITION: this.searchForm,
            CURRENT_PAGE: this.currentPage,
          });
          window.addEventListener('beforeunload', () => {
            sessionStorage.setItem('store', JSON.stringify(this.$store.state));
          });
        } else {
          this.newOrderListData = [];
          this.totalCount = 0;
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
        this.loading = false;
      }).catch((error) => {
        this.loading = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // --------------------------------------------获取供应商信息列表
    querySupplier() {
      queryActiveSupplierList().then((list) => {
        this.supplier = list;
        this.customers = list;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // -------------------------------------------导出订单
    output(row) {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            ORDER_ID: Number(row.ID),
          };
          exportHistoryFun(params).then((result) => {
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    // -------------------------------------------导出所有订单
    exportHistoryOrder() {
      this.submitExportDate(1);
    },
    exportAllOrder() {
      this.submitExportDate(0);
    },
    // 拉取代采客户
    queryPurchsse() {
      const params = {
        SERVICE_ID: '10001',
        OTYPE: 17,
        PRINCIPAL_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        if (result.length > 0) {
          this.purchaseList = result;
        }
      });
    },
    // 转换代采订单
    changeAllOrder() {
      this.purchaseDialog = true;
    },
    submitPurchase() {
      if (!this.purchaseForm.PRINCIPAL) {
        this.$message.show({ text: '请选择客户', type: 'warning' });
        return;
      }
      if (!this.purchaseForm.START_DAY || !this.purchaseForm.END_DAY) {
        this.$message.show({ text: '请选择开始和结束日期', type: 'warning' });
        return;
      }
      // 关账限制
      if (this.$util.isOrderClosedRange([this.purchaseForm.START_DAY, this.purchaseForm.END_DAY])) {
        this.$message.show({ text: '日期范围内存在已关账月份，无法对已关账月份内订单进行操作', type: 'warning' });
        return false;
      }

      for (let i = 0; i < this.purchaseList.length; i++) {
        if (this.purchaseForm.PRINCIPAL === this.purchaseList[i].ID) {
          this.IS_SUPPLIER_CLIENT = this.purchaseList[i].IS_SUPPLIER_CLIENT;
        }
      }
      const params = {
        SERVICE_ID: '10003',
        OTYPE: 42,
        PRINCIPAL_ID: Number(sessionStorage.getItem('tcId')),
        CUSTOMER_ID: this.purchaseForm.PRINCIPAL,
        IS_SUPPLIER_CLIENT: this.IS_SUPPLIER_CLIENT,
        START_DAY: this.purchaseForm.START_DAY,
        END_DAY: this.purchaseForm.END_DAY,
      };
      http.post(params).then((result) => {
        this.purchaseDialog = false;
        this.$message.show({ text: '操作成功', type: 'success' });
        this.queryNewOrderListData();
      });
    },
    submitExportDate(FLAG) {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
          };
          if (this.searchForm.DAY_INTERVAL != null && this.searchForm.DAY_INTERVAL.length == 2) {
            params.START_DATE = this.searchForm.DAY_INTERVAL[0];
            params.END_DATE = this.searchForm.DAY_INTERVAL[1];
          } else {
            this.$message.show({ text: '请选择日期范围', type: 'warning' });
            document.body.style.cursor = 'default';
            return false;
          }
          if (this.searchForm.SUPPLIER) {
            params.SUPPLIER_ID = this.searchForm.SUPPLIER;
          }
          if (this.searchForm.orderCode) {
            params.ORDER_ID = this.searchForm.orderCode;
          }
          if (FLAG == 1) {
            params.ORDER_STATUS = [5, 6, 7, 8, 9, 10];
          }
          if (this.searchForm.采购类型) {
            params.ORDER_TYPE = this.searchForm.采购类型;
          }
          if (this.searchForm.SUB_WAREHOUSE && this.searchForm.SUB_WAREHOUSE[0]) {
            params.GYS_ID_LIST = this.searchForm.SUB_WAREHOUSE;
          }
          exportHistoryAllFun(params).then((result) => {
            if (result[0]) {
              if (result[0].FILE_PATH) {
                window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
              }
              if (result[0].TASK_CREATED_SUCCESSFULLY) {
                this.$util.getUnreadInformation(this);
                this.$confirm(this.$util.appointmentMessage, '温馨提示', {
                  confirmButtonText: '确定', cancelButtonText: '取消', type: 'success', dangerouslyUseHTMLString: true,
                }).then(() => {
                  this.$router.push({ name: 'appointmentHandling' });
                }).catch(() => {
                  this.$message.show({ type: 'info', text: '取消操作' });
                });
              }
            }
            this.exportTatolDialog = false;
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    close() {
      this.exportTatolDialog = false;
      this.copyFormVisible = false;
    },
    handleCurrentChange() {
      this.queryNewOrderListData();
    },
    // 点击筛选按钮触发
    handleSearch() {
      this.currentPage = 1;
      this.queryNewOrderListData();
    },
    printOrder(row) {
      this.$router.push({ name: 's_pricePrint' });
      sessionStorage.setItem('orderId', row.ID);
      this.nameForm.companyName = sessionStorage.getItem('company');
      sessionStorage.setItem('shopDocTitle', this.nameForm.companyName);
    },
    submitPrint() {
      this.$router.push({ name: 's_pricePrint' });
      sessionStorage.setItem('shopDocTitle', this.nameForm.companyName);
    },
    shortPrintOrder(row) {
      this.$router.push({ name: 'historyShortPrint' });
      sessionStorage.setItem('打印订单ID', true);
      sessionStorage.setItem('orderIdS', row.ID);
      sessionStorage.setItem('shopDocTitle', this.nameForm.companyName);
    },
    // 单个订单导出
    exportOrderList(row) {
      const submitArr = [];
      submitArr.push(row.ID);
      const params = {
        ORDER_IDS: submitArr,
      };
      exportNewOrdeFun(params).then((result) => {
        window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
        this.queryNewOrderListData();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    leavePage() {
      sessionStorage.removeItem('sellOrderID');
    },
    exportMonthlyDeliveryRecordSummary() {
      if (!this.monthlyDeliveryRecordSummaryForm.MONTH) {
        this.$message.show({ text: '请选择月份', type: 'warning' });
        return;
      }
      const params = {
        SERVICE_ID: '15069',
        OTYPE: 10,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        MONTH: this.monthlyDeliveryRecordSummaryForm.MONTH,
      };
      if (this.monthlyDeliveryRecordSummaryForm.SUPPLIER_ID_LIST && this.monthlyDeliveryRecordSummaryForm.SUPPLIER_ID_LIST[0]) {
        params.SUPPLIER_ID_LIST = this.monthlyDeliveryRecordSummaryForm.SUPPLIER_ID_LIST;
      }
      http.post(params).then((res) => {
        if (res[0].FILE_PATH) {
          window.location.href = this.$util.getURLLocalHost(res[0].FILE_PATH);
        }
        if (res[0].TASK_CREATED_SUCCESSFULLY) {
          this.$util.getUnreadInformation(this);
          this.$confirm(this.$util.appointmentMessage, '温馨提示', {
            confirmButtonText: '确定', cancelButtonText: '取消', type: 'success', dangerouslyUseHTMLString: true,
          }).then(() => {
            this.$router.push({ name: 'appointmentHandling' });
          }).catch(() => {
            this.$message.show({ type: 'info', text: '取消操作' });
          });
        }
        this.closeMonthlyDeliveryRecordSummaryDialog();
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    closeMonthlyDeliveryRecordSummaryDialog() {
      this.monthlyDeliveryRecordSummaryDialog = false;
      this.$refs.monthlyDeliveryRecordSummaryForm.resetFields();
    },
  },
  destroyed() {
    this.leavePage();
  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/shopOrderManage/s_HistoryOrderList.vue